import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorSurfaceActionMeetingIntelligence, colorTextInverseStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SampleBadge, ThumbnailContainer, ThumbnailLoader, Thumbnail, ThumbnailPlaceholder, MeetingTimeBadge } from './styles';
import { WandIcon } from '../../../header';
const contentCss = "c1fw3pmi";
const contentIsPhoneCss = "c15lahvg";
const contentIsListViewCss = "c1dev5vd";
const Content = forwardRef((props, ref) => {
  const {
    isListView,
    ...restProps
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <div ref={ref} {...restProps} className={classNames(contentCss, {
    [contentIsPhoneCss]: isPhone && !isListView
  }, {
    [contentIsListViewCss]: isListView
  }, props.className)} />;
});
export const MeetingThumbnail = ({
  isFetching,
  thumbnail,
  duration,
  isListView,
  isSample
}) => <ThumbnailContainer isListView={isListView}>
    <Content isListView={isListView}>
      {isSample && <SampleBadge>
          <BodyText color={colorSurfaceActionMeetingIntelligence} size="small" weight="bold">
            {I18n.t('publisher.meeting_intelligence.details.badge.sample_recap')}
          </BodyText>
        </SampleBadge>}
      {isFetching && <ThumbnailLoader />}
      {!isFetching && (thumbnail ? <Thumbnail src={thumbnail} alt="" /> : <ThumbnailPlaceholder>
            <WandIcon />
          </ThumbnailPlaceholder>)}
      <MeetingTimeBadge>
        <BodyText color={colorTextInverseStandard} size="x-small">{duration}</BodyText>
      </MeetingTimeBadge>
    </Content>
  </ThumbnailContainer>;

require("./meeting_thumbnail.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_thumbnail.js");